import Vue from 'vue'
import Router from 'vue-router'

import homeRoute from './home.route'
import templateRoute from './template.route'
import payRoute from './pay.route'
import siteRoute from './site.route'
import galleryRoute from './gallery.route'
import certificateRoute from './certificate.route'

Vue.use(Router)

let routes = [...templateRoute, ...payRoute, ...siteRoute, ...homeRoute, ...galleryRoute,...certificateRoute]


export default new Router({
	routes,
	scrollBehavior (to, from, savedPosition) {
		return { x: 0, y: 0 }
	}
})
